import {
    GET_TYPING_VEHICLES_REQUEST,
    GET_VEHICLES_REQUEST,
    GET_VEHICLES_SUCCESS,
    GET_VEHICLES_FAILURE,
    GET_VEHICLES_TYPE_REQUEST,
    GET_VEHICLES_TYPE_SUCCESS,
    GET_VEHICLES_TYPE_FAILURE,
    GET_VEHICLES_BRAND_REQUEST,
    GET_VEHICLES_BRAND_SUCCESS,
    GET_VEHICLES_BRAND_FAILURE,
    GET_VEHICLES_MODEL_REQUEST,
    GET_VEHICLES_MODEL_SUCCESS,
    GET_VEHICLES_MODEL_FAILURE,
    SUBMIT_VEHICLE_FILE_REQUEST,
    SUBMIT_VEHICLE_FILE_SUCCESS,
    SUBMIT_VEHICLE_FILE_FAILURE,
    SET_VEHICLE_FILE,
    SET_VEHICLES
} from '../actions/vehicles';

const initialState = {
    vehicles: [],
    vehicles_type: [],
    vehicles_brand: [],
    vehicles_model: [],
    fetching_vehicles_type: false,
    fetching_vehicles_brand: false,
    fetching_vehicles_model: false,
    fetching: false,
    vehicle_file: "",
    submitFetchingFile: false,
    submitSuccessFile: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_TYPING_VEHICLES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_VEHICLES_REQUEST: {
            return {
                ...state,
                fetching: true
            };
        }
        case GET_VEHICLES_SUCCESS: {
            return {
                ...state,
                fetching: false,
                vehicles: action.payload.vehicles
            };
        }
        case GET_VEHICLES_FAILURE: {
            return {
                ...state,
                fetching: false
            };
        }
        case GET_VEHICLES_TYPE_REQUEST: {
            return {
                ...state,
                fetching_vehicles_type: true
            };
        }
        case GET_VEHICLES_TYPE_SUCCESS: {
            return {
                ...state,
                fetching_vehicles_type: false,
                vehicles_type:
                    action.payload.vehicles_type !== null ? action.payload.vehicles_type : state.vehicles_type
            };
        }
        case GET_VEHICLES_TYPE_FAILURE: {
            return {
                ...state,
                fetching_vehicles_type: false
            };
        }
        case GET_VEHICLES_BRAND_REQUEST: {
            return {
                ...state,
                fetching_vehicles_brand: true
            };
        }
        case GET_VEHICLES_BRAND_SUCCESS: {
            return {
                ...state,
                fetching_vehicles_brand: false,
                vehicles_brand: action.payload.vehicles_brand
            };
        }
        case GET_VEHICLES_BRAND_FAILURE: {
            return {
                ...state,
                fetching_vehicles_brand: false
            };
        }
        case GET_VEHICLES_MODEL_REQUEST: {
            return {
                ...state,
                fetching_vehicles_model: true
            };
        }
        case GET_VEHICLES_MODEL_SUCCESS: {
            return {
                ...state,
                fetching_vehicles_model: false,
                vehicles_model: action.payload.vehicles_model
            };
        }
        case GET_VEHICLES_MODEL_FAILURE: {
            return {
                ...state,
                fetching_vehicles_model: false
            };
        }
        case SUBMIT_VEHICLE_FILE_REQUEST: {
            return {
                ...state,
                submitFetchingFile: true,
                submitSuccessFile: false
            };
        }
        case SUBMIT_VEHICLE_FILE_SUCCESS: {
            return {
                ...state,
                submitFetchingFile: false,
                submitSuccessFile: true
            };
        }
        case SUBMIT_VEHICLE_FILE_FAILURE: {
            return {
                ...state,
                submitFetchingFile: false,
                submitSuccessFile: false
            };
        }
        case SET_VEHICLE_FILE: {
            return {
                ...state,
                vehicle_file: action.payload.vehicle_file,
                submitSuccessFile: false
            };
        }
        case SET_VEHICLES: {
            return {
                ...state,
                vehicles: action.payload.vehicles
            };
        }
        default:
            return state;
    }
};
